const ADMIN = 'Admin';
const RESEARCHER = 'Bench Scientist';

const roles = [
    ADMIN,
    RESEARCHER
]

export default class RolesPermissionsMap {
    isAuthorized(payload) {
      // this is used to validate if the roles can proceed
      if (payload && payload.length > 0) {
        payload.forEach(x => {
            if (roles.includes(x)) {
                return true;
            } else {
                return false;
            }
        });
      } else {
          return false;
      }
    }

    isOwner(user) {
        // this is used to check if the viewer is owner of the scan
        let owner = sessionStorage.getItem('uid');
        return owner === user ? true : false;
    }
}